import script from "./puzzle.vue?vue&type=script&setup=true&lang=ts"
export * from "./puzzle.vue?vue&type=script&setup=true&lang=ts"

import "./puzzle.vue?vue&type=style&index=0&id=67920737&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67920737"]])

export default __exports__